import { create } from "zustand";

interface PopUpsStore {
  popUpDelete: [string | number, boolean];
  setPopUpDelete: (value: [string | number, boolean]) => void;
}

export const usePopUpsStore = create<PopUpsStore>((set) => ({
  popUpDelete: ["", false],
  setPopUpDelete: (value: [string | number, boolean]) =>
    set((store) => ({ ...store, popUpDelete: value })),
}));
